import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../consts/api";

export const useToggleTimeTrackingConfig = (id, options = {}) => {
  const res = useMutation(
    (dto) =>
      http.patch(
        HTTP_ENDPOINTS.timeclockSettings.toggleTimeTrackingConfigs(id),
        dto,
      ),
    {
      ...options,
    },
  );
  return res;
};
